
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 50","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('filter',{attrs:{"x":"-18.8%","y":"-13.8%","width":"137.5%","height":"137.5%","filterUnits":"objectBoundingBox","id":"a"}},[_c('feMorphology',{attrs:{"radius":".5","operator":"dilate","in":"SourceAlpha","result":"shadowSpreadOuter1"}}),_c('feOffset',{attrs:{"dy":"2","in":"shadowSpreadOuter1","result":"shadowOffsetOuter1"}}),_c('feGaussianBlur',{attrs:{"stdDeviation":"2","in":"shadowOffsetOuter1","result":"shadowBlurOuter1"}}),_c('feComposite',{attrs:{"in":"shadowBlurOuter1","in2":"SourceAlpha","operator":"out","result":"shadowBlurOuter1"}}),_c('feColorMatrix',{attrs:{"values":"0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0","in":"shadowBlurOuter1"}})]),_c('rect',{attrs:{"id":"b","x":"0","y":"0","width":"40","height":"40","rx":"2"}})]),_c('g',{attrs:{"fill-rule":"nonzero","fill":"none"}},[_c('g',{attrs:{"transform":"translate(5 3)"}},[_c('use',{attrs:{"fill":"#000","filter":"url(#a)","xlink:href":"#b"}}),_c('use',{attrs:{"stroke":"#9F9EA0","fill":"#FFF","xlink:href":"#b"}})]),_c('path',{attrs:{"d":"M31.977 15H17.713a.67.67 0 00-.597.364.68.68 0 00.052.707l5.226 7.362.006.007c.19.257.292.567.293.886v6.002a.668.668 0 00.93.62l2.937-1.12c.263-.08.437-.33.437-.628v-4.874c0-.319.104-.63.293-.886l.006-.007 5.226-7.362a.679.679 0 00.053-.707.67.67 0 00-.598-.364z","fill":"#4788C6"}})])])
          )
        }
      }
    